<select class="form-select" [disabled]="readonly" [(ngModel)]="value">
  @for (option of options; track option) {
<option value="{{option.value}}">{{option.name}}</option>
}
</select>
<span class="{{readonly ? 'disabled' : ''}} ups-select-icon"></span>
